
/* eslint-disable indent */
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import './index.scss';

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root');

class DeleteConfirm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: true,
    };
  }  

  render() {
      const { modelopen,closeDeleteModel,deleteStaff,staffManagement,staff} = this.props;
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={closeDeleteModel}
          className="Create-Modal"
          overlayClassName="Overlay"
          contentLabel="Example Modal"
        >
            <div>
            <div className="modal-header">
              <div className="title">Remove Staff Member</div>
              <button className="modal-close" onClick={closeDeleteModel}>X</button>
              <div className="description">
                Once removed the staff member will no longer be able to login, unless added by admin again.
              </div>
              <div className="actions">
                  <button className="btn btn--primary btn--lg" onClick={()=>deleteStaff(staff)} >
                    {staffManagement.deleteuser? 'Removing...': 'REMOVE'} 
                  </button>
                  <button className="btn btn--secondary btn--lg" onClick={closeDeleteModel}>CANCEL</button>
              </div>
            </div>
            </div>
        
        </Modal>
      </div>
    );
  }
}

export default DeleteConfirm;